import api from '@/services/api';
const ENTITY_ENDPOINT = 'suaje';

export class SuajeService {
  /**
   * Obtiene todos los suajes con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los suajes con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Obtiene todos los suajes con adaptadores cilindro-desarrollo
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API con una fila por suaje-adaptador
   */
  static async findAllWithAdaptadores(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/adaptadores`, { params });
  }

  /**
   * Obtiene todos los suajes con adaptadores utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API con una fila por suaje-adaptador
   */
  static async findAllWithAdaptadoresQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}/adaptadores?${queryString}`);
  }

  /**
   * Obtiene un suaje por su código
   * @param {string|number} codigo - Código del suaje
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findByCodigo(codigo) {
    return await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
  }

  /**
   * Crea un nuevo suaje
   * @param {Object} suaje - Datos del suaje a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(suaje) {
    return await api.post(`/${ENTITY_ENDPOINT}`, suaje);
  }

  /**
   * Actualiza un suaje existente
   * @param {string|number} codigo - Código del suaje
   * @param {Object} suaje - Datos del suaje a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(codigo, suaje) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${codigo}`, suaje);
  }

  /**
   * Elimina un suaje
   * @param {string|number} codigo - Código del suaje
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(codigo) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${codigo}`);
  }
}

export default SuajeService;
